import { User, UpdateProfileRequest, UpdatePasswordRequest } from '../../types/user.response';
import axios from 'axios';
import { apiClient } from './client.api';

export const usersApi = {
    getUser: async (): Promise<User> => {
        try {
            const response = await apiClient.get('/users/me');
            return response.data.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                throw new Error(error.response?.data || error.message || 'Failed to fetch user data');
            }
            throw error;
        }
    },

    updateProfile: async (data: UpdateProfileRequest): Promise<User> => {
        try {
            const response = await apiClient.patch('/users/me', data);
            return response.data;
        } catch (error) {
            if (axios.isAxiosError(error)) {
                const msg = error.response?.data?.message || error.response?.data || error.message || 'Failed to update profile';
                throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg));
            }
            throw error;
        }
    },

    updatePassword: async (data: UpdatePasswordRequest): Promise<void> => {
        try {
            await apiClient.patch('/users/me/password', data);
        } catch (error) {
            if (axios.isAxiosError(error)) {
                throw new Error(error.response?.data || error.message || 'Failed to update password');
            }
            throw error;
        }
    },
}